import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import MultiCloud from "../../assests/MenuServies/MultiCloudVisibility.svg";
import "./MultiCloudVisibility.css"; // fixed import syntax
import wire from "../../assests/smart-wire.svg";
import { Col, Row } from "react-bootstrap";
import devops from "../../../src/assests/DevOps.svg"
import secure from "../../../src/assests/SecureCloud.svg"

const MultiCloudVisibility: React.FC = () => {
  return (
        <div style={{display:"flex",justifyContent:"center"}}>
    <div className="pt-5 multi-service-multi">
        <h2 className=" mb-2  multi-h2">Performance & Reliability at Scale</h2>
        <p className="text-center performance-p-multi mb-5">Reduce costs | Ensure uptime | Streamline operations</p>

        {/* IoT Solutions */}
        <Row className="align-items-center mb-5  card-image-1 card-padding-multi">
          <Col md={7} xs={12}>
            <div className="p-4  h-100">
              <h4 className=" mb-4 multi-h4">Hybrid & Multi-Cloud Optimization</h4>
         <span className="badge   mb-3 smart-badge">
            Predictable costs. No surprises. 
           </span>
              <ul className="mb-0 multi-ul">
                <li>Optimize enterprise workloads across <span className="bold-span">AWS, Azure, Google Cloud</span>, and hybrid environments for <span className="bold-span">scalability and cost efficiency</span>. </li>
                <li>Implement <span className="bold-span">cloud orchestration </span>and management tools to reduce infrastructure complexity and improve agility. </li>
                {/* <li><span className="bold-span">Automated recommendations </span>to remove idle or underutilized resources.</li> */}
                {/* <li>Proven results: clients typically save <span className="bold-span">15–25% in monthly spend within 30–45 days</span>.</li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-end mt-3 mt-md-0">
            <img src={wire} alt="IoT Solutions" className="img-fluid" />
          </Col>
        </Row>

        {/* Robotics Solutions */}
        <Row className="align-items-center mb-5 flex-md-row-reverse  card-image-2-13 card-padding-multi">
          <Col md={7} xs={12}>
            <div className="p-4  h-100">
              <h4 className=" mb-4 multi-h4">Cloud Migration & Modernization</h4>
       <span className="badge   mb-3 multi-badge">
            Your entire cloud ecosystem in one place
         </span>
              <ul className="mb-0 multi-ul">
                <li>Seamlessly <span className="bold-span">migrate legacy applications and databases to cloud-native architectures</span>. </li>
                <li>Ensure <span className="bold-span">zero-downtime migration</span> while modernizing infrastructure for enhanced performance and security. </li>
                {/* <li>Custom-built dashboards tailored to your environment and KPIs.</li> */}
                {/* <li><span className="bold-span"> Eliminate confusion</span> from scattered reports and complex billing statements.</li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-start mt-3 mt-md-0">
            <img
              src={MultiCloud}
              alt="Robotics Solutions"
              className="img-fluid"
            />
          </Col>
        </Row>


                {/* IoT Solutions */}
        <Row className="align-items-center mb-5  card-image-1-12 card-padding-multi">
          <Col md={7} xs={12}>
            <div className="p-4  h-100">
              <h4 className=" mb-4 multi-h4">DevOps & FinOps </h4>
         <span className="badge   mb-3 devops-badge">
            Optimize pipelines and costs
           </span>
              <ul className="mb-0 multi-ul">
                <li>Establish <span className="bold-span">CI/CD pipelines</span> to accelerate software delivery with automated testing and deployment. </li>
                <li>Optimize cloud spend using <span className="bold-span">FinOps practices</span>, reducing costs without compromising performance. </li>
                {/* <li><span className="bold-span">Automated recommendations </span>to remove idle or underutilized resources.</li> */}
                {/* <li>Proven results: clients typically save <span className="bold-span">15–25% in monthly spend within 30–45 days</span>.</li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-end mt-3 mt-md-0">
            <img src={devops} alt="IoT Solutions" className="img-fluid" />
          </Col>
        </Row>

        {/* Robotics Solutions */}
        <Row className="align-items-center flex-md-row-reverse  card-image-2-12 card-padding-multi">
          <Col md={7} xs={12}>
            <div className="p-4  h-100">
              <h4 className=" mb-4 multi-h4">Secure Cloud Operations</h4>
       <span className="badge   mb-3 cloud-badge">
            Ensure data protection and compliance
         </span>
              <ul className="mb-0 multi-ul">
                <li>Implement<span className="bold-span"> cloud security best practices</span> including compliance, monitoring, and threat detection. </li>
                <li>Provide <span className="bold-span">continuous cloud operations monitoring </span>for proactive risk management and business continuity.  </li>
                {/* <li>Custom-built dashboards tailored to your environment and KPIs.</li> */}
                {/* <li><span className="bold-span"> Eliminate confusion</span> from scattered reports and complex billing statements.</li> */}
              </ul>
            </div>
          </Col>
          <Col md={5} xs={12} className="text-start mt-3 mt-md-0">
            <img
              src={secure}
              alt="Robotics Solutions"
              className="img-fluid"
            />
          </Col>
        </Row>
    </div>
    </div>
  );
};

export default MultiCloudVisibility;
